import React from 'react'

import { i18n, I18nextProvider } from '../../i18n'

const I18nProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}

export { I18nProvider }
